import './WritePostButtonWrapper.scss';

const WritePostButtonWrapper = ({ children }) => {
  return <div className="WritePostButtonWrapper">{children}</div>;
};

export default WritePostButtonWrapper;
